const packageName = 'languages'

export const GET_LANGUAGES = `${packageName}/GET_LANGUAGES`
export const GET_LANGUAGES_SUCCESS = `${packageName}/GET_LANGUAGES_SUCCESS`
export const GET_LANGUAGES_FAIL = `${packageName}/GET_LANGUAGES_FAIL`
